export const ROUTE_SEGMENTS = {
  catalog: 'catalog-v2',
  pricing: 'pricing-v2',
  cart: 'shop-v2/cart',
  cartV1: 'shop/cart',
  checkout: 'shop-v2/checkout',
  account: 'account',
  search: 'search',
};

export const ROUTE_PATHS = {
  pricing: `/:language/${ROUTE_SEGMENTS.pricing}/:url_key/`,
  cart: `/:language/${ROUTE_SEGMENTS.cart}/`,
  cartV1: `/:language/${ROUTE_SEGMENTS.cartV1}/`,
  catalog: `/:language/${ROUTE_SEGMENTS.catalog}/`,
  search: `/:language/${ROUTE_SEGMENTS.search}/`,

  // Account
  account: `/:language/${ROUTE_SEGMENTS.account}/`,
  overview: `/:language/${ROUTE_SEGMENTS.account}/overview/`,
  orders: `/:language/${ROUTE_SEGMENTS.account}/orders/`,
  orderDetail: `/:language/${ROUTE_SEGMENTS.account}/orders/:orderNumber/`,
  settings: `/:language/${ROUTE_SEGMENTS.account}/settings/`,

  // Checkout
  checkout: `/:language/${ROUTE_SEGMENTS.checkout}/`,
  address: `/:language/${ROUTE_SEGMENTS.checkout}/address/`,
  delivery: `/:language/${ROUTE_SEGMENTS.checkout}/delivery/`,
  payment: `/:language/${ROUTE_SEGMENTS.checkout}/payment/:status?/:orderCartId?`,
  review: `/:language/${ROUTE_SEGMENTS.checkout}/review/`,
  success: `/:language/${ROUTE_SEGMENTS.checkout}/success/:orderNumber/`,
};
